"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.throwError = exports.throwMessage = exports.toMessage = exports.toAudioNotFoundError = exports.toDOMError = exports.toValidationError = exports.fromString = exports.toFileSystemError = exports.toUnknownError = exports.toDomainError = exports.decodeWith = exports.Type = void 0;
const adt_1 = require("@morphic-ts/adt");
const prelude_1 = require("@packages/prelude");
const io_ts_reporters_1 = require("io-ts-reporters");
const serialize_error_1 = require("serialize-error");
exports.Type = (0, adt_1.makeADT)('_tag')({
    HttpError: (0, adt_1.ofType)(),
    LookupError: (0, adt_1.ofType)(),
    ValidationError: (0, adt_1.ofType)(),
    FileSystemError: (0, adt_1.ofType)(),
    DomainError: (0, adt_1.ofType)(),
    UnknownError: (0, adt_1.ofType)(),
    DOMError: (0, adt_1.ofType)(),
    AudioNotFoundError: (0, adt_1.ofType)()
});
const decodeWith = (decoder) => (input) => (0, prelude_1.pipe)(input, decoder.decode, prelude_1.E.mapLeft(errors => exports.Type.of.ValidationError({ errors: (0, io_ts_reporters_1.formatValidationErrors)(errors), input })));
exports.decodeWith = decodeWith;
const toDomainError = (message, type = prelude_1.t.any) => (data) => exports.Type.of.DomainError({ data, type, message });
exports.toDomainError = toDomainError;
const toUnknownError = (error) => exports.Type.of.UnknownError({
    error: (0, serialize_error_1.serializeError)(error)
});
exports.toUnknownError = toUnknownError;
const toFileSystemError = (path) => (error) => exports.Type.of.FileSystemError({
    path,
    error: (0, serialize_error_1.serializeError)(error)
});
exports.toFileSystemError = toFileSystemError;
const fromString = (message) => exports.Type.of.UnknownError({
    error: (0, serialize_error_1.serializeError)(new Error(message))
});
exports.fromString = fromString;
const toValidationError = (errors) => exports.Type.of.ValidationError({
    errors: (0, io_ts_reporters_1.formatValidationErrors)(errors),
    input: errors
});
exports.toValidationError = toValidationError;
const toDOMError = (selector) => exports.Type.of.DOMError({
    selector
});
exports.toDOMError = toDOMError;
const toAudioNotFoundError = (id) => exports.Type.of.AudioNotFoundError({
    id
});
exports.toAudioNotFoundError = toAudioNotFoundError;
const formatMessage = prefix => (0, prelude_1.flow)(prelude_1.O.fromPredicate(prelude_1.s.isString), prelude_1.O.getOrElse(() => `${prefix} without details`));
exports.toMessage = exports.Type.matchStrict({
    UnknownError: ({ error }) => (0, prelude_1.pipe)(error.message, formatMessage('UnknownError')),
    ValidationError: ({ errors }) => errors.join('\n'),
    HttpError: ({ request, status }) => `${request.method} ${request.url}: ${status.text} (${status.code})`,
    LookupError: ({ key }) => `Lookup error for key (${key})`,
    FileSystemError: ({ error }) => (0, prelude_1.pipe)(error.message, formatMessage('FileSystemError')),
    DomainError: error => `DomainError: ${error.message} | type: ${error.type.name} | data: ${JSON.stringify(error.data)}`,
    DOMError: ({ selector }) => (0, prelude_1.pipe)(selector, formatMessage('DOMError')),
    AudioNotFoundError: ({ id }) => `Audio not found for id (${id})`
});
const throwMessage = (message) => {
    throw new Error(message);
};
exports.throwMessage = throwMessage;
const throwError = (error) => (0, prelude_1.pipe)(error, exports.toMessage, exports.throwMessage);
exports.throwError = throwError;
//# sourceMappingURL=Error.js.map